// removed by extract-text-webpack-plugin
module.exports = {"grid":"src-components-pages-Homepage----Homepage-module---grid---38nyG","contentWrapper":"src-components-pages-Homepage----Homepage-module---contentWrapper---38qIV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Homepage/Homepage.module.sass
// module id = 423
// module chunks = 35783957827783